module.exports = __webpack_public_path__ + "static/img/hypnose-05.f0c642d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hypnose-05.png
// module id = 99
// module chunks = 0